import FormManualTransaction from './FormManualTransaction.vue';

export default FormManualTransaction;
